import React, { useState, useEffect } from 'react';

export default function CamerasPage({ apiUrl }) {
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/api/cameras`)
      .then(r => r.json())
      .then(d => { setCameras(d); setLoading(false); })
      .catch(e => { console.error(e); setLoading(false); });
  }, [apiUrl]);

  if (loading) return <div style={{ padding: '20px' }}>Loading...</div>;

  return <div style={{ padding: '20px' }}><h1>Cameras</h1><p>Total Cameras: {cameras.length}</p></div>;
}